import updateBus from "../bus/updateBus";
import eventHub from "../mixins/eventHub";
import {Call} from "@/data/Call";
import {AutoCall} from "@/data/AutoCall";

export default function getSocketPlugin(socket) {
  return (store) => {
    socket.on('data', (data, received) => {
      for (const list of Object.keys(data.lists)) {
        data.lists[list] = data.lists[list].map(entityId => data.entities[entityId]);
      }
      store.commit('simulationData', data);
      // store.commit('refreshTime'); // surplus refresh time (first is in timingPlugin.js) causing weird timer/clock behavior in scenario view
      received();
    });
    socket.on('logout', async (received) => {
      console.log('received logout');
      await store.dispatch('logout');
      received();
    });

    socket.on('update', async (event) => {
      updateBus.$emit('update', event);
    });
    const initialization = async () => {
      if (!store.state.online) {
        store.commit('online');
        await store.dispatch('checkToken');
      }
    };
    const offlineHandler = () => {
      if (store.state.online) {
        store.commit('offline');
      }
    };
    socket.on('reconnect', initialization);
    socket.on('connect', initialization);
    socket.on('disconnect', offlineHandler);
    socket.on('error', offlineHandler);
    socket.on('reconnecting', offlineHandler);
    socket.on('connect_error', () => {
      console.error('socket unavailable');
    });
    // Used for debug purposes. Messages are shown on the message bus.
    socket.on('message', (m) => {
      console.log('Should show message:', m);
      eventHub.$emit('openMessageController', 'success', m);
    });


    // Test event; return the message to sender
    // For the sender to receive the message, he MUST pass `awaitResponse: true` to the api call inside 'payload'
    socket.on('parrot', (message, from, callback) => {
      callback(null, message)
    })

    socket.on('callInvite', (message, from) => {
      if (store.state.call === null) {
        // Sets up a new call, CallUI listens to the store and thus will find out about the change and
        // alter its UI to allow some user interaction (accept/decline the call)
        store.state.call = new Call(false, from, store)
      }
      else {
        eventHub.$emit('openMessageController', 'info', 'Hovor od uživatele ' + from.email + ' automaticky odmítnut (již jste v hovoru/aktivní vyzvánění).')
        store.dispatch('callApi', {name: 'sendToUser', payload: {id: from.id, event: 'declineCall'}})
      }
    })
    socket.on('declineCall', (message, from) => {
      if (store.state.call && store.state.call.to.id === from.id) {
        store.state.call.hang()
        store.state.call = null
      }
    })
    socket.on('acceptCall', (message, from) => {
      if (store.state.call && store.state.call.to.id === from.id) {
        store.state.call.connectRtc()
      }
    })
    socket.on('requestAccepted', async (message, from, callback)=>{
      console.log('someone accepted our call request!');
      console.log('store.state.call', store.state.call);
      if (store.state.call.request === true && !store.state.call.to) {
        console.log('Connecting rtc');
        store.state.call.to = {id: message.responderId}
        store.state.call.connectRtc()
      }
      callback()
    })
    socket.on('useAnsweringMachine', (callRequestId, eventId)=>{
      const call = store.state.call
      if (call && call.request === true && call.status === 'ring') {
        store.state.call = null
        store.state.autocallcall = new AutoCall(call.eventId, this, false)
      }
      callRequestId, eventId
    })


    // These are hardwired RTC protocol negotiation messages
    socket.on('rtcCandidate', (candidate, from) => {
      if (store.state.call && store.state.call.to.id === from.id) {
        store.state.call.addCandidate(candidate)
      }
    })
    socket.on('rtcOffer', (offer, from) => {
      if (store.state.call && store.state.call.to.id === from.id) {
        store.state.call.handleOffer(offer)
      }
    })
    socket.on('rtcAnswer', (answer, from) => {
      if (store.state.call && store.state.call.to.id === from.id) {
        store.state.call.handleAnswer(answer)
      }
    })
  }
}
